import Vue from "vue";
import Favorites from "../favorites/components/Favorites.vue";

document.addEventListener("DOMContentLoaded", (_) => {
  const el = document.getElementById("favorites");
  const props = {
    PropIsFavorite: JSON.parse(el.getAttribute("data-prop-is-favorite")),
    staffProfileId: JSON.parse(el.getAttribute("data-staff-profile-id")),
  };

  new Vue({
    el: "#favorites",
    render: (h) => h(Favorites, { props }),
  });
});
